import {
  getlistRolesDatas,
  getlistmenuDatas,
  getlistfieldsDatas,
  setFieldsDatas
} from '@/services/config'
export default {
  namespaced: true,
  state: {
    submitting: false,
    datasReady: false,
    menuDatasReady: false,
    datas: [],
    menuDatas: {},
    activeMenuData: {},
    form: '',
    decorators: {
    }
  },
  getters: {
    enableshare (state, getters, rootState) {
      const { baseinfo = {} } = rootState
      const { enableshare } = baseinfo
      return enableshare
    }
  },
  mutations: {
    // 设置数据容器的值
    setDatas (state, datas) {
      state.datas = datas
      state.datasReady = true
    },
    setSubmitting (state, type) {
      state.submitting = type
    },
    setForm (state, form) {
      state.form = form
    },
    setMenuDatas (state, datas) {
      // console.log(this.enableshare)
      const { enableshare } = this
      if (datas['inquiry-all']) {
        let { child = {} } = datas['inquiry-all'] || {}
        for (let k in child) {
          if (!enableshare && (k === 'inquiry-manager-share' || k === 'inquiry-share')) {
            child[k].state = false
          }
        }
      }
      if (datas['inquiry-mine']) {
        let { child = {} } = datas['inquiry-mine'] || {}
        for (let k in child) {
          if (!enableshare && k === 'inquiry-share') {
            child[k].state = false
          }
        }
      }
      state.menuDatas = datas
      state.menuDatasReady = true
    },
    setActiveMenuData (state, data) {
      state.activeMenuData = data
    }
  },
  actions: {
    async getlistRolesDatas ({ commit }) {
      const chain = await getlistRolesDatas()
        .onSuccess((raw) => {
          commit('setDatas', raw)
        })
        .config({ tip: false })
      return chain
    },
    async getlistmenuDatas ({ commit }) {
      const chain = await getlistmenuDatas()
        .onSuccess((raw) => {
          commit('setMenuDatas', raw)
        })
        .config({ tip: false })
      return chain
    },
    async getlistfieldsDatas ({ commit }) {
      const chain = await getlistfieldsDatas()
        .onSuccess((raw) => {
          // commit('setMenuDatas', raw)
        })
        .config({ tip: false })
      return chain
    },
    async setFieldsDatas ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await setFieldsDatas()
        .onSuccess(async () => {
          // const res = await dispatch('fetchCollectDatas', type)
          // res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        // .config({ tip: false })
      return chain
    }

  }
}
